import { createAtom, useSelector } from '@tanstack/react-store';
import { validate as isUuid } from 'uuid';

interface TimesheetStore {
  synced: boolean;
}

export type TimesheetsStore = Record<string, TimesheetStore>;

const initialState: TimesheetsStore = {};

export const timesheetsAtom = createAtom<TimesheetsStore>(initialState);

export function setSyncStatus({ timesheetId, synced }: { timesheetId: string; synced: boolean }) {
  // Protect against prototype pollution
  if (!isUuid(timesheetId)) return;

  timesheetsAtom.set((current) => {
    const existing = current[timesheetId];

    if (existing?.synced === synced) {
      return current;
    }

    return {
      ...current,
      [timesheetId]: { synced },
    };
  });
}

export function useTimesheetSyncStatus(timesheetId: string) {
  return useSelector(timesheetsAtom, (state) => state[timesheetId]?.synced ?? false);
}
